import { FieldPath, FieldValues, useController } from "react-hook-form";
import React, { ComponentProps } from "react";
import { Autocomplete } from "@mui/material";
import { RhfInputProps } from "../../../../../Forms/RhfInputProps";
import { OptionalLabelProps } from "../../../../../Forms/OptionalLabelProps";
import { TextFieldReadOnly } from "./TextFieldReadOnly";
import { MuiSelectChip } from "../../../../../Layout/Select/MuiSelectChip";

type EnumMultiSelectProps = {
  options: { Key: number; Value: string }[];
};

export const EnumMultiSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  options,
}: RhfInputProps<TFieldValues, TName> &
  ComponentProps<"select"> &
  OptionalLabelProps &
  EnumMultiSelectProps) => {
  const { field } = useController({
    control,
    name,
  });

  const labels = Object.fromEntries(options.map((o) => [o.Key, o.Value]));

  return (
    <Autocomplete
      {...field}
      multiple
      options={options ?? []}
      value={options.filter((menuItem) => field.value.includes(menuItem.Key))}
      getOptionLabel={(option) => option.Value}
      onChange={(_, selectedValues) => {
        field.onChange(selectedValues.map((item) => item.Key));
      }}
      renderInput={({ inputProps, ...rest }) => (
        <TextFieldReadOnly {...rest} inputProps={inputProps} label={label} />
      )}
      renderTags={(values, getTagProps) =>
        values.map((value, index) => (
          <MuiSelectChip
            getTagProps={getTagProps}
            labels={labels}
            index={index}
            valueId={value.Key}
          />
        ))
      }
      size="small"
      filterSelectedOptions
      disableCloseOnSelect
    />
  );
};
